import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { createFormFieldsByIdGetter, createInitialValues } from 'client/helpers/formikHelpers';

import SrCard, {
  SR_CARD_BULLET_COLOR_BLUE,
  SR_CARD_CONTENT_TYPE_FORM_GRID,
} from 'client/components/SrCard/SrCard';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrBox from 'client/components/SrBox';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrFooterSaveButton from 'client/components/SrFooterSaveButton';

const getFormFields = () => {
  return [
    {
      id: 'informationCompletenessEnabled',
      title: 'Ask if they have all marketing info from the owner?',
      type: 'yes_no',
    },
    {
      id: 'referralFeeEnabled',
      title: 'Ask Lease Referral Fee?',
      type: 'yes_no',
    },
  ];
};

const SrPartnerMarketingSunriseSettingsForm = ({ partner, onSubmit, inProgress }) => {
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={createInitialValues({
        formFields: getFormFields(),
        defaultValues: partner.experienceConfiguration,
      })}
      render={(formikBag) => {
        const formFields = getFormFields();
        const getFormFieldsById = createFormFieldsByIdGetter(formFields);

        return (
          <>
            <Form>
              <SrCard
                color={SR_CARD_BULLET_COLOR_BLUE}
                contentType={SR_CARD_CONTENT_TYPE_FORM_GRID}
                header="Market Property Form"
              >
                <SrGridRow>
                  <SrFormikField
                    formField={getFormFieldsById('informationCompletenessEnabled')}
                    formikBag={formikBag}
                    theme={SR_FIELD_THEME_ADOBE}
                  />
                  <SrBox height="50px" />
                  <SrFormikField
                    formField={getFormFieldsById('referralFeeEnabled')}
                    formikBag={formikBag}
                    theme={SR_FIELD_THEME_ADOBE}
                  />
                  <SrBox height="50px" />
                </SrGridRow>
              </SrCard>

              <SrStaticFooter>
                <span />
                <SrFooterSaveButton isSubmitting={inProgress} />
              </SrStaticFooter>
            </Form>
          </>
        );
      }}
    />
  );
};

SrPartnerMarketingSunriseSettingsForm.propTypes = {
  partner: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  inProgress: PropTypes.bool.isRequired,
};

SrPartnerMarketingSunriseSettingsForm.displayName = 'SrPartnerMarketingSunriseSettingsForm';

export default SrPartnerMarketingSunriseSettingsForm;
